/* eslint-disable indent */
import React from 'react';
import Modal from 'react-modal';
import helper from '../../helpers';
import Loading from '../../../common/Loading';
import './index.scss';

Modal.setAppElement('#root');

const reverseList = (list) => {
  let reverselist = [];
  for (let i = list.length - 1; i >= 0; i--) {
    reverselist.push(list[i]);
  }
  return reverselist;
};

const checkforMatch = (listnumber, input) => {
  if (listnumber && listnumber.replace('+1', '').replace(/\D/g, '') === input.replace('+1', '').replace(/\D/g, '')) {
    return true;
  } else {
    return false;
  }
};

class Layover extends React.Component {
  constructor(props) {
    super(props);
    this.closeModal = this.closeModal.bind(this);
    this.sendReport = this.sendReport.bind(this);
    this.unblockPhone = this.unblockPhone.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.sendButtonStatus = this.sendButtonStatus.bind(this);
    this.sendButtonStatus = this.sendButtonStatus.bind(this);
    this.state = {
      name: '',
      error: false,
      unblockingnumber: '',
      errorMessage: 'Please enter valid phone number',
      list: [],
    };
  }

  componentDidMount() {
    const { phone } = this.props;
    let error = false;
    let errorMessage = 'Please enter valid phone number';
    if (this.props.errorData.blockedNumbers &&
      this.props.errorData.blockedNumbers.length > 0 &&
      this.props.errorData.blockedNumbers.filter((block) => {
        return checkforMatch(block.phone, phone);
      }).length > 0
    ) {
      error = true;
      errorMessage = 'This number is already blocked';
    }
    this.setState({
      phone: this.props?.isBlocked ? '' : phone,
      error,
      errorMessage,
    });
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.errorData && nextProps.errorData.errorReportSucess && !nextProps.errorData.postErrorReport) {
      if (nextProps.errorData.errorReport.status === 'success') {
        // this.closeModal()
      } else {
        this.setState({
          error: true,
          errorMessage: nextProps.errorData.errorReport.message,
        });
      }
    }
    if (nextProps.errorData.getBlockedNUmber === undefined) {
      const { business, auth } = nextProps;
      const { studio_id } = auth;
      const bzid = business.id || studio_id;
      this.props.getBlockUser(bzid);
    } else if (nextProps.errorData.blockedNumbers) {
      this.setState({
        list: nextProps.errorData.blockedNumbers,
      });
    }
    if (!nextProps.errorData.getBlockedNUmber && nextProps.errorData.blockedNumberSuccess) {
      this.setState({
        list: nextProps.errorData.blockedNumbers,
      });
    }
  }

  closeModal() {
    this.props.setblockOverlayVisibility(false);
    this.props.clearReportFlags();
    this.setState({
      phone: '',
      unblockingnumber: '',
      error: false,
    });
  }

  sendReport() {
    const { selectedConversation, business, auth } = this.props;
    const { studio_id } = auth;
    const bzid = business.id || studio_id;
    let params = {
      businessId: selectedConversation?.bzId || bzid,
      number: this.state.phone,
      blocked_by: business.info.EMAIL,
    };
    this.props.blockUser(params);
  }

  unblockPhone(number) {
    const { selectedConversation, business, auth } = this.props;
    const { studio_id } = auth;
    const bzid = business.id || studio_id;
    this.setState({
      unblockingnumber: number,
    });
    let params = {
      businessId: selectedConversation?.bzId || bzid,
      number,
      blocked_by: business.info.EMAIL,
    };
    this.props.unblockPhone(params);
  }

  handleChange(event) {
    let error = false;
    let errorMessage = 'Please enter valid phone number';
    if (!helper.validatePhoneNumber(event.target.value)) {
      error = true;
    } else if (this.props.errorData.blockedNumbers &&
      this.props.errorData.blockedNumbers.length > 0 &&
      this.props.errorData.blockedNumbers.filter((block) => { return checkforMatch(block.phone, event.target.value); }).length > 0
    ) {
      error = true;
      errorMessage = 'This number is already blocked';
    }
    this.setState({
      phone: event.target.value,
      error,
      errorMessage,
    });
  }

  sendButtonStatus() {
    const { phone } = this.state;
    const { errorData } = this.props;
    if (phone) {
      if (phone.trim().length > 0 && !this.state.error) {
        return !!(errorData && errorData.postErrorReport);
      } else {
        return true;
      }
    } else {
      return true;
    }
  }

  render() {
    const { modelopen, errorData, selectedConversation } = this.props;
    const { error, errorMessage, unblockingnumber } = this.state;
    return (
      <div>
        <Modal
          isOpen={modelopen}
          onAfterOpen={this.afterOpenModal}
          onRequestClose={this.closeModal}
          className="Modal"
          overlayClassName="overlay-top"
          contentLabel="Example Modal"
        >
          <div>
            {(errorData && !(errorData.errorReportSucess || errorData.unblockSuccess)) &&
              <div>
                <div className="modal-header">
                  <div className="title">Block number</div>
                  <button className="modal-close" onClick={this.closeModal}>X</button>
                  <div className="sub-title">Once you block someone’s number they will not be able to contact you via
                    the truelark system, but they may still be able to reach you on the phone. This person will not
                    be allowed to text from this number and no client profiles associated with
                    this number will be allowed to make a booking.!</div>
                  <div className="input">
                    <label className="label">phone number</label>
                    <div className="block-number">
                      <input type="text" className={error ? 'error-input' : ''} value={this.state.phone} onChange={(event) => this.handleChange(event)} maxLength="100" />
                      <button className="btn btn--primary btn--lg" onClick={this.sendReport} disabled={this.sendButtonStatus()}>
                        {(errorData && errorData.postErrorReport) ? 'blocking...' : 'BLOCK     '}
                      </button>
                    </div>
                    {error && <div className="error-message">{errorMessage}</div>}
                  </div>
                </div>
                {errorData.blockedNumbers && errorData.blockedNumbers.length > 0 &&
                  <div className="blocked-list">
                    <div className="title">Blocked numbers <span>({errorData.blockedNumbers.length}):</span></div>
                    {errorData.getBlockedNUmber ?
                      (<div className="conversation_loader">
                        <Loading />
                      </div>)
                      :
                      (<div className="content">
                        {reverseList(errorData.blockedNumbers).map((phone, index) => {
                          return (<div key={index} className="phone-number"><div className="phone-number_number">{phone.user_phone}</div><div className="phone-number_unblock" onClick={() => this.unblockPhone(phone.user_phone)}>  {(errorData && errorData.postunblockNumber && unblockingnumber === phone.user_phone) ? 'Unblocking...' : 'Unblock     '} </div></div>);
                        })
                        }
                      </div>)
                    }
                  </div>
                }
              </div>
            }
            {(errorData && errorData.errorReportSucess && !errorData.postErrorReport) &&
              <div className="modal-header">
                <div className="title">Blocking success</div>
                <button className="modal-close" onClick={this.closeModal}>X</button>
                <div className="sub-title">This number {errorData?.errorReport?.number} will not be allowed to text or call into TrueLark.
                </div>
                <div className="actions">
                  <button className="btn btn--primary btn--lg" onClick={this.closeModal}>
                    OK
                  </button>
                </div>
              </div>
            }

            {(errorData && errorData.unblockSuccess && !errorData.postunblockNumber) &&
              <div className="modal-header">
                <div className="title">Unblocking success</div>
                <button className="modal-close" onClick={this.closeModal}>X</button>
                <div className="sub-title">This number {errorData?.errorReport?.number} will be allowed to text or call into TrueLark.
                </div>
                <div className="actions">
                  <button className="btn btn--primary btn--lg" onClick={this.closeModal}>
                    OK
                  </button>
                </div>
              </div>
            }
          </div>
          {this.props.children}
        </Modal>
      </div>
    );
  }
}

export default Layover;
